export default __webpack_public_path__ + "static/media/06.d8a4d9a9.png";